/*
 *   File : banner-button.js
 *   Author : https://evoqins.com
 *   Description : CTA button used on dark banner cards
 *   Integrations : NA
 *   Version : 1.0.0
*/

function BannerButton(props) {
    return (
        <button type="button"
            className={`e-bg-white e-text-night e-border-radius-10 padding-12px-tb px-4 e-primary-font-inter e-font-weight-600 e-font-14 e-line-height-100 no-border no-outline ${props.disabled ? "cursor-default opacity-7" : "cursor-pointer"} ${props.className}`}
            disabled={props.disabled}
            id={props.id}
            onClick={(e) => props.onPress(e)}>
            {props.name}
        </button>
    )
};

BannerButton.defaultProps = {
    onPress: () => { },
    className: "",
    id: null,
    name: null,
}

export default BannerButton;
